import React from "react";

export default function HugMySelfPage() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">🧠 HugMySelf</h1>
      <p className="mb-6 text-lg">A Mental Health Ecosystem, Powered by Compassion + AI</p>
      <p className="mb-4">HugMySelf is a holistic platform designed to support your mental and emotional wellbeing. It combines AI with therapeutic tools to help users:</p>
      <ul className="list-disc list-inside mb-6">
        <li>💬 Journal their thoughts safely</li>
        <li>🎙️ Talk to an empathetic AI listener</li>
        <li>📊 Track mood, progress, and patterns</li>
        <li>🌱 Practice self-care and reflection</li>
      </ul>
      <p className="mb-4">Whether you're navigating stress, anxiety, or just need space to breathe — HugMySelf is your private, judgment-free sanctuary.</p>
      <p className="mb-4 font-semibold">Built with care.<br />Backed by science.<br />Protected by privacy.</p>
    </div>
  );
}
